import { ClientsListScreenContent } from "../../features/clientsList";

// ClientsListScreen — route landing for /clients.
// Thin composition wrapper around the feature widget. No selectors,
// no dispatch, no state — all owned by the widget.
//
// Substrate: canonical .clients-page from modernize.css. CL-5
// collapses the header band into the widget so that the parent of
// the T-1 create-client modal (ClientsListScreenContent) directly
// owns both the trigger affordance in .clients-header__actions and
// the open-state controlling the modal — per R8 §4 T-1 ("modal
// triggered from parent header; mutation owns slice; success
// refetches parent on close"). The screen wrapper is now purely
// the canonical .clients-page page envelope.

function ClientsListScreen() {
  return (
    <section className="clients-page" id="Csection" tabIndex="-1">
      <div className="container">
        <ClientsListScreenContent />
      </div>
    </section>
  );
}

export default ClientsListScreen;
